import { Lookup } from "src/app/model/lookup";

export class Program {
    constructor(        
        public ProgramName: string = '',
        public Resources: Lookup[] = [],
        public Languages: Lookup[] = [],
        public ContactPersonName: string = '',
        public ContactPersonEmailAddress: string = '',
        public ContactPersonPhone: string = '',
        public ZipCodes: Lookup[] = [],
        public FreeOfCharge: string = '',
        public PaymentType: string = '',
        public OtherPaymentType: string = '',
        public PopulationType: string = '',
        public AgeType: string = '',
        public AgeTypes: Lookup[] = [],
        public Purpose: string = '',
        public Website: string = '',
        public IsApproved: boolean = false,
        public CanDisableCharge : boolean = false,
    ) { }
}
